import React from "react";
import { Col } from "reactstrap";
import assetPath from "~/utils/assetPath";
import pluralize from "pluralize";
import LinkComponent from "~/components/LinkComponent";

export function collectionColumn(collection) {
  return (
    <Col xs="12" sm="6" md="4" className="collection_container">
      <If condition={is.existy(collection)}>
        <LinkComponent
          to={`/collections/${collection.id}`}
          data-href={`/collections/${collection.id}`}
          addQueryParameters={true}
          onClick={event => { this.handleLinkClick(event) }}
        >
          <div className="images_container">
            <div className="left_image_container">
              <img
                className="lazyload"
                data-src={_.nth(collection.preview_photos, 0) ? _.nth(collection.preview_photos, 0).urls.regular : ''}
              />
              <div className="shadow_overlay" />
              <div className="text_overlay">
                <img alt="Show puzzles" src={assetPath("preview_large", "png")} />
                <p>Show puzzles</p>
              </div>
            </div>
            <div className="right_image_container">
              <div className="small_image_container">
                <img
                  className="lazyload"
                  data-src={_.nth(collection.preview_photos, 1) ? _.nth(collection.preview_photos, 1).urls.small : ''}
                />
                <div className="shadow_overlay" />
              </div>
              <div className="small_image_container">
                <img
                  className="lazyload"
                  data-src={_.nth(collection.preview_photos, 2) ? _.nth(collection.preview_photos, 2).urls.small : ''}
                />
                <div className="shadow_overlay" />
              </div>
              <div className="small_image_container">
                <img
                  className="lazyload"
                  data-src={_.nth(collection.preview_photos, 3) ? _.nth(collection.preview_photos, 3).urls.small : ''}
                />
                <div className="shadow_overlay" />
              </div>
            </div>
          </div>
          <p className="title">{collection.title}</p>
          <p className="amount">{pluralize('puzzle', collection.total_photos, true)}</p>
        </LinkComponent>
      </If>
    </Col>
  );
}



// WEBPACK FOOTER //
// ./src/routes/collections/components/CollectionsComponent/helpers/elements.js